var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready && _vm.breadcrumb)?[_c('div',{staticClass:"mb-3"},[_c('Breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1)]:_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }